import { Box, styled } from "@mui/material";

export const ManagePlanStyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "1rem",
  maxWidth: "35rem",
  width: "100%",
}));

export const PetAvatarWithPlansStyled = styled(Box)(({ theme })=>({
  "display": "flex",
  "padding": "0rem 1rem",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "0.75rem",

  "h4": {
    fontWeight: "bold",
  },

  "h6 span": {
    fontWeight: "bold",
  },

}));

export const PlanDetailStyledContainer = styled(Box)(({ theme }) => ({
  "display": "flex",
  "padding": "1rem",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1rem",
  "alignSelf": "stretch",
  "borderRadius": "0.5rem",
  "border": `1px solid ${theme.palette.taupe.dark}`,
  "backgroundColor": theme.palette.white.main,

  ".detail_section": {
    "display": "flex",
    "alignItems": "flex-start",
    "gap": "0.75rem",
    "alignSelf": "stretch",

    ".sub_details_section": {
      "display": "flex",
      "flexDirection": "column",
      "alignItems": "flex-start",
      "gap": "0.25rem",
    },
  },
}));
